import React, { useState } from "react";

const faqs = [
  {
    question: "Do I have a valid personal injury case?",
    answer:
      "A case may exist if you were injured due to another person's negligence, unsafe conduct, or reckless behavior. A consultation can help determine the next steps and assess your specific situation.",
  },
  {
    question: "What should I do after a car accident?",
    answer:
      "Seek medical attention immediately, document the scene with photos, exchange information with all parties, file a police report, and contact Figgers Law before speaking with insurance companies. Early action protects your legal rights.",
  },
  {
    question: "What if the insurance company contacts me?",
    answer:
      "Do not provide a recorded statement or accept any settlement offers before consulting with an attorney. Insurance companies have experienced adjusters working to minimize payouts—you deserve equal representation.",
  },
  {
    question: "How much compensation may be available?",
    answer:
      "Compensation varies based on medical expenses, lost wages, pain and suffering, property damage, and future care needs. Each case is unique.",
    hasLink: true,
  },
  {
    question: "Do I pay upfront legal fees?",
    answer:
      "Figgers Law works on a contingency fee basis for personal injury cases—meaning you pay no upfront fees. We only collect if we successfully recover compensation for you.",
  },
];

const FAQSection = () => {
  const [openFaq, setOpenFaq] = useState(0);

  const toggleFaq = (index) => {
    setOpenFaq((prev) => (prev === index ? null : index));
  };

  return (
    <section className="faqs" id="faqs">
      <div className="container">
        <div className="faqs-inner">
          <div
            className="section-label"
            style={{ justifyContent: "center" }}
          >
            FAQs
          </div>

          <h2>Frequently Asked Questions</h2>

          <p className="faqs-sub">
            Clear answers to common questions injury victims may have before
            speaking with an attorney.
          </p>

          {faqs.map((faq, index) => {
            const isOpen = openFaq === index;

            return (
              <div className="faq-item" key={index}>
                <button
                  type="button"
                  className={`faq-btn ${isOpen ? "open" : ""}`}
                  aria-expanded={isOpen}
                  onClick={() => toggleFaq(index)}
                >
                  <span>{faq.question}</span>

                  <svg
                    className="faq-arrow"
                    width="20"
                    height="20"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <path d="m6 9 6 6 6-6" />
                  </svg>
                </button>

                <div
                  className={`faq-body ${isOpen ? "open" : ""}`}
                  style={{
                    maxHeight: isOpen ? "300px" : "0",
                    overflow: "hidden",
                    transition: "max-height .35s ease",
                  }}
                >
                  <p>
                    {faq.answer}

                    {faq.hasLink && (
                      <>
                        {" "}
                        Our{" "}
                        <a
                          href="#"
                          style={{ color: "var(--gold)" }}
                          onClick={(e) => e.preventDefault()}
                        >
                          Settlement Calculator
                        </a>{" "}
                        can provide a general estimate.
                      </>
                    )}
                  </p>
                </div>
              </div>
            );
          })}

          {/* <div className="faqs-more">
            <a
              href="#"
              className="btn-outline-ink"
              onClick={(e) => e.preventDefault()}
            >
              View All FAQs
            </a>
          </div> */}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;